<template>
    <transition name="fade">
        <div class="WebsiteDialogue" v-show="websiteDialogueVisible" @click="toggleWebsiteDialogue()" :style="{ zIndex: fullScreen ? '99999999' : '1' }">
            <div class="wd-container" @click="$event.stopPropagation()"  :style="{ width: fullScreen ? '100%' : '90%' , height: fullScreen ? '100%' : '85%' , marginTop: fullScreen ? '0px' : '30px' ,  borderRadius: fullScreen ? '0px' : '10px'}"><!--stopPropagation so toggleWebsiteDialogue() wont trigger on dialogue itself -->
                
                <!-- Toolbar -->
                <div class="wd-bar">
                    <input v-if="showURL" class="wd-bar-link" disabled="true" type="text" v-bind:value="this.url">
                    <div class="wd-bar-buttons">  
                        <md-button class="md-icon-button" @click="openLink()">
                            <OpenInNewIcon class="openInNewIconIcon"/>
                        </md-button>
                        <!-- <md-button class="md-icon-button" @click="toggleFullsize()" :class="{ 'v3-active': fullScreen }">
                            <FullScreenIcon v-if="!fullScreen"/>
                            <FullScreenExitIcon v-else/>
                        </md-button> -->
                        <md-button class="md-icon-button" @click="toggleWebsiteDialogue()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <!-- Website -->
                <iframe class="wd-iframe" v-bind:src="this.url" frameborder="0" :style="{ borderRadius: fullScreen ? '0px' : '0px 0px 10px 10px'}" />
            </div>         

        </div>  
    </transition>
</template>

<style scoped>
    .WebsiteDialogue{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
    }
    .wd-container{
        position: absolute;
        margin-top: 30px;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
    }
    .wd-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
    }
    .wd-bar-link {
        width: calc(90% - 92px);
        padding: 10px;
        border: .5px solid rgb(180, 180, 180);
        background: rgb(241, 241, 241);
        border-radius: 6px;
        font-size: 16px;
        font-family: var(--primaryFont), Helvetica, Arial, sans-serif;
        cursor: text;
    }
    .wd-bar-link::selection{
        color: rgb(238, 238, 238);
    }
    .wd-bar-link:focus {
        outline: none;          
    }
    .wd-bar-buttons{
        margin-left: auto;
    }
    .wd-iframe{
        width: 100%;
        height: calc(100% - 46px);
        overflow-x: hidden;
        border-radius: 0px 0px 10px 10px;
    }
    .material-design-icon {
        height: 2.2em;
        width: 2.2em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: black;
        height: 2.2em;
        width: 2.2em;
    }
    .v3-active .material-design-icon  > .material-design-icon__svg{
        fill: white !important;
    }
    .v3-active.md-button{
        background: var(--primaryColor);
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: rgb(252, 113, 113);
        height: 2.5em;
        width: 2.5em;
    }
     .material-design-icon.openInNewIconIcon {
        height: 1.9em;
        width: 1.9em;
    }
    .material-design-icon.openInNewIconIcon> .material-design-icon__svg {
        height: 1.9em;
        width: 1.9em;
    }

    /* Mobile */
    @media (max-device-width: 900px){
        .wd-screen{
            z-index: 99;
        }
  }
</style>
    
<script>
import {mapMutations} from 'vuex';

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'
import FullScreenIcon from 'vue-material-design-icons/Fullscreen.vue'
import FullScreenExitIcon from 'vue-material-design-icons/FullscreenExit.vue'

export default {
    components: {CloseIcon,OpenInNewIcon,FullScreenIcon,FullScreenExitIcon},
    inject: ['toggleCommunication'], 
    data: function () {
        return {
            websiteDialogueVisible: false,
            showURL: true, //Wether url at the top of the dialogue shoukd be visible
            url: "",
            fullScreen: false   
        }
    }, 
	methods: {
        ...mapMutations(["setDialogueOpen"]),

        // Toggles visibility of this dialogue
        toggleWebsiteDialogue(){
            this.websiteDialogueVisible=!this.websiteDialogueVisible;
            this.url = "";
            this.setDialogueOpen(this.websiteDialogueVisible);

            if(this.fullScreen)
                this.toggleFullsize();
        },

        toggleFullsize(){
            this.fullScreen = !this.fullScreen;
            this.toggleCommunication();
        },

        // Opens Link in separate window
        openLink(){
            window.open(this.url, '_blank');
        },

        // Displays this dialogue and changes url
        initDialogue: function(e) {
            this.toggleWebsiteDialogue();
            this.url = e.detail.url; 
            this.showURL = e.detail.showURL;       
        },
    },

    // Add Eventlistener that displays and initializes this dialogue. Event gets fired inside URLButton component
    mounted: function(){
        window.addEventListener('openURL',this.initDialogue);
    }
}

</script>